var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col-7" }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.notificationsGroupDate(this.$vnode.key)) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.notifications, function(notification) {
        return _c("NotificationItem", {
          key: notification.id,
          attrs: { notification: notification },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-036bc358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036bc358","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationGroup.vue
// module id = null
// module chunks = 